import React, { FunctionComponent } from 'react';
import { InternalLink } from '../../internal-link/internal-link';
import styles from './navbar-link.module.scss';

export interface INavbarLinkProps {
  name: string;
  url?: string;
  isActive?: boolean;
  extraClass?: string;
  colorWhite: boolean;
}

export const NavbarLink: FunctionComponent<INavbarLinkProps> = props => {
  const { name, url, isActive, extraClass, colorWhite } = props;

  const currentClass = isActive
    ? styles.internalLinkActive
    : styles.internalLink;

  return url ? (
    <InternalLink
      activeClassName={styles.active}
      url={url}
      className={`${
        !extraClass ? currentClass : styles[extraClass]
      } ${colorWhite && styles.white}`}
    >
      {name}
    </InternalLink>
  ) : (
    <div className={!extraClass ? currentClass : styles[extraClass]}>
      {name}
    </div>
  );
};
